import { render, staticRenderFns } from "./force-password-change.vue?vue&type=template&id=010c0045&scoped=true&"
import script from "./force-password-change.js?vue&type=script&lang=js&"
export * from "./force-password-change.js?vue&type=script&lang=js&"
import style0 from "./force-password-change.scss?vue&type=style&index=0&id=010c0045&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010c0045",
  null
  
)

export default component.exports